<template>
    <BaseModal
        :id="'static-history'"
        :title="`History ${title}`"
        size="xl"
        :message="message !== undefined ? message : default_message"
        :link_message="link_message"
        :link_event="link_event"
        @linkEvent="linkEmitReceiver()"
    >
        <template v-slot:breadcrumb>
            <Breadcrumb :breadcrumb="breadcrumb"/>
        </template>
        <template v-slot:content>
            <div class="w-100 table-responsive defaultproject__table overflow-y--2" v-if="histories && histories.length">
                <table class="table">
                    <thead>
                        <tr>
                            <th v-for="(item, i) in history_table_headers" :key="i" scope="col" v-html="item.name"/>
                            <th v-if="change_type" :key="'change_type'" scope="col" v-html="'Change Type'"/>
                        </tr>
                    </thead>
                    <tbody>
                        <template v-for="(item, i) in histories">
                            <template v-if="item.fields && item.fields.length">
                                <tr v-for="(field, j) in item.fields" :key="j">
                                    <td v-html="item.user_name"/>
                                    <td v-html="format_date(item.performed_at)"/>
                                    <td v-html="getDictionary(field.key)"/>
                                    <td :title="field.old" v-html="format_string(field.old, field.key)"/>
                                    <td :title="field.new" v-html="format_string(field.new, field.key)" />
                                    <td v-html="item.action === 'Updating' ? 'Updated' : item.action"/>
                                    <td v-if="change_type" v-html="getDictionary(item.model_type)"/>
                                </tr>
                            </template>
                            <template v-else>
                                <tr  :key="i">
                                    <td v-html="item.user_name"/>
                                    <td v-html="format_date(item.performed_at)"/>
                                    <td v-html="'N/A'"/>
                                    <td v-html="'N/A'"/>
                                    <td v-html="'N/A'"/>
                                    <td v-html="item.action === 'Updating' ? 'Updated' : item.action"/>
                                    <td v-if="change_type" v-html="getDictionary(item.model_type)"/>
                                </tr>
                            </template>
                        </template>
                    </tbody>
                </table>
            </div>
        </template>
    </BaseModal>
</template>

<script>
import BaseModal    from './BaseModal'
import Breadcrumb   from '@/components/BreadcrumbComponent/Breadcrumb'

export default {
    name: 'HistoryModal',

    props: [
        'title',
        'histories',
        'breadcrumb',
        'message',
        'link_message',
        'link_event',
        'change_type',
    ],

    data() {
        return {
            history_table_headers: [
                { 
                    name:   'Change made by',
                },
                {   
                    name:   'Change made on',
                },
                {
                    name:   'Field Changed',
                },
                {
                    name:   'Old',
                },
                {
                    name:   'New',
                },
                {
                    name:   'Action'
                }
            ],

            dictionary: {
                associate_id:               'Associate',
                supervisor_id:              'Supervisor',
                shift_id:                   'Shift',
                group_id:                   'Group',
                cost_center_department_id:  'Department',
                days_per_week:              'Days/Week',
                avg_time_day:               'Avg. Time',
                building_id:                'Building',
                level_id:                   'Level',
                sq_footage:                 'Sq. Footage:',
                daily_shift_1:              'Daily Shift 1',
                daily_shift_2:              'Daily Shift 2',
                daily_shift_3:              'Daily Shift 3',
                policing_shift_1:           'Policing Shift 1',
                policing_shift_2:           'Policing Shift 2',
                policing_shift_3:           'Policing Shift 3',
                project_shift_1:            'Project Shift 1',
                project_shift_2:            'Project Shift 2',
                project_shift_3:            'Project Shift 3',
                area_id:                    'Area',
                room_type_id:               'Room Type',
                cost_center_id:             'Cost Center',
                door_number:                'Door Number',
                walking_number:             'Walking Number',
                sq_ft:                      'S. Feet',
                time_adjustment:            'Time Adjustment',
                work_group:                 'Work Group 2',
                exclude_daily:              'Exclude Dailys',
                exclude_project:            'Exclude Projects',
                essential_cleaning:         'Essential Cleaning',
                floor_id:                   'Floor',
                daily_task_id:              'Daily Task',
                
                'App\\Models\\Room\\Room':  'Room Record Change',
                'App\\Models\\Bed\\Bed':    'Bed/Fixtures Change'
            },
            default_message: `This record has a history of all the changes made to it since its creation. You can view each modification, including who made it and when it was made, by scrolling through the timeline below.`
        };
    },

    components: {
        BaseModal,
        Breadcrumb,
    },

    methods: {

        linkEmitReceiver()
        {
            this.$emit('linkEventReceiver', true)
        },

        format_date(value)
        {
            value = new Date(value)
            return `${value.toISOString().split('T')[0]} at ${value.toLocaleTimeString()}`
        },

        display_table(index)
        {
            window.$(`#static-fields-${index}`).modal('show')
        },

        getDictionary(key)
        {
            return this.dictionary[key] || key.charAt(0).toUpperCase() + key.slice(1)
        },

        format_string(value, key)
        {
            if (key === 'description')
            {
                value = value ? String(value) : 'N/A'
                return value;
                // return value.length > 5 ? value.match(/.{1,15}/g).join('</br>') : value
            }

            return value;

            // return typeof value === "boolean" ? (value ? 'Yes' : 'No') : (String(value).length > 15 ? value.substring(0,15) + '...' : value);
        },
    }
}
</script>